import { render } from "./telegram-icon.vue?vue&type=template&id=001c8f48"
import script from "./telegram-icon.vue?vue&type=script&lang=js"
export * from "./telegram-icon.vue?vue&type=script&lang=js"

import "./telegram-icon.vue?vue&type=style&index=0&id=001c8f48&lang=css"
script.render = render

export default script